
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/CrazysalesReturnPolicy",
      function () {
        return require("private-next-pages/article/CrazysalesReturnPolicy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/CrazysalesReturnPolicy"])
      });
    }
  